import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import employeeService from '../../../services/Employee.service'

import { BrokerDialogType } from './common'
import { LoadingButton } from '../common/LoadingButton'

import { Modal, ModalContent, ModalStyle } from '@amzn/stencil-react-components/modal'
import { Label, Text } from '@amzn/stencil-react-components/text'
import { Select } from '@amzn/stencil-react-components/form'
import { Col, Row } from '@amzn/stencil-react-components/layout'
import { Button, ButtonVariant } from '@amzn/stencil-react-components/dist/submodules/button'
import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner'

export class BrokerDialog extends Component {

  createAccountHandler = (shouldGoToBroker) => {
    this.props.onSelectedBroker(this.props.broker, shouldGoToBroker);
  }

  cancelElectionHandler = () => {
    this.props.onPendingBroker(this.props.broker.code);
  }

  completeAtBrokerHandler = () => {
    this.props.onCloseDialog();
    var brokerUrl = employeeService.getBrokerUrl(this.props.broker, this.props.employee);
    if (brokerUrl != '#') {
      window.open(brokerUrl, '_blank');
    }
  }

  getButtonList = (t, readyDialog) => {
    var buttonList = [];
    if (this.props.dialogType === BrokerDialogType.Select) {
      buttonList.push(
        <LoadingButton
          onClick={() => this.createAccountHandler(readyDialog)}
          disabled={this.props.viewOnly}
          variant={ButtonVariant.Primary}
          text={t('SelectBrokerDialog.CreateAccount', { broker: this.props.broker.name })}
          loading={this.props.loading}
          dataTestId={'create-account-btn'}
        />
      );
    } else if (this.props.dialogType === BrokerDialogType.Pending) {
      buttonList.push(
        <LoadingButton
          onClick={() => this.cancelElectionHandler()}
          disabled={this.props.viewOnly}
          variant={ButtonVariant.Secondary}
          text={t("BrokerPendingDialog.CancelElection")}
          loading={this.props.loading}
          dataTestId={'cancel-election-btn'}
        />
      );

      if (readyDialog) {
        buttonList.push(
          <Button onClick={() => this.completeAtBrokerHandler()} disabled={this.props.viewOnly}
                  variant={ButtonVariant.Primary} dataTestId={'complete-at-broker-btn'}>
            {t("BrokerPendingDialog.CompleteAtBroker")}
          </Button>
        )
      } else {
        buttonList.push(
          <Button onClick={() => this.props.onCloseDialog()} disabled={this.props.viewOnly}
                  variant={ButtonVariant.Primary} dataTestId={'back-later-btn'}>
            {t("BrokerPendingDialog.BackLater")}
          </Button>
        )
      }
    }

    return buttonList;
  }

  getTitleText = (t, dialogType, broker) => {
    if (dialogType === BrokerDialogType.Select) {
      return t('SelectBrokerDialog.Title', { broker: broker.name });
    } else if (dialogType === BrokerDialogType.Pending) {
      return t('BrokerPendingDialog.Title', { broker: broker.name });
    }
  }

  setReadyDialog = (broker, employee) => {
    if (broker.code === 'FIDELITY') {
      if (!employee.broker_inumber) {
        // inumber NULL
        // Fidelity does not require an SSN and self-routes US vs OUS (no-SSN employees get an
        // iNumber), so eligibility must not be gated on valid_ssn_in or region (P470529165).
        return employee.fidelity_activated_in !== null
      } else if(employee.fidelity_activated_in === null) {
        return false
      }
    }
    return true
  }

  formatHtmlContent = (readyDialog, brokerContent, broker, employee) => {
    var htmlContent = ''
    if (broker.code === 'FIDELITY') {
      const parent = readyDialog ? brokerContent.withINumber : brokerContent.withoutINumber

      parent.forEach(el => {
        if (el.paragraphs) {
          htmlContent += el.paragraphs.map(p => {
            return `<p>${p}</p><br/>`
          }).join('')
        } else if (el.list) {
          htmlContent += '<ol style="list-style-type: decimal; padding-left: 40px;">' + el.list.map(li => `<li>${li}</li>`).join('') + '</ol>'
        }

      })
    } else {
      htmlContent = brokerContent.paragraphs.map(p => `<p>${p}</p>`).join('')
    }

    return htmlContent.replace(/\{\{iNumber\}\}/g, `<strong>${employee.broker_inumber || 'N/A'}</strong>`)
  }

  render() {
    const { t, broker, employee, content, viewOnly, dialogType } = this.props;

    if (!this.props.visible) {
      return null
    }

    const jsonContent = JSON.parse(content)
    const brokerContent = jsonContent[this.props.broker.code]

    if (!brokerContent) {
      return null
    }

    let readyDialog = this.setReadyDialog(broker, employee);
    let htmlContent = this.formatHtmlContent(readyDialog, brokerContent, broker, employee);

    return (
      <Modal dataTestId={'broker-dialog-modal'}
             isOpen={this.props.visible}
             style={ModalStyle.Default}
             close={this.props.onCloseDialog}>
        <ModalContent
          titleText={this.getTitleText(t, dialogType, broker)}
          closeButtonAltText="Close Button For Broker Dialog"
          onCloseButtonClick={this.props.onCloseDialog}
          buttons={this.getButtonList(t, readyDialog)}
        >
          <Col gridGap="S300">
            {readyDialog &&
              <MessageBanner type={"warning"}>
                {t('SelectBrokerDialog.PopupMessage')}
              </MessageBanner>
            }
            <Text dangerouslySetInnerHTML={{ __html: htmlContent }}></Text>
          </Col>
        </ModalContent>
      </Modal>
    )
  }
}

const mapState = state => ({
  content: state.static_content.select_and_pending_broker_dialog,
  employee: state.employee
});

export default connect(mapState)(withTranslation('translationsV2')(BrokerDialog))

